import type {
  FilterFunc,
  FilterState,
  FilterType,
} from "@/components/controls/grid/columnfilters/ColumnFilters";
import { buildApplyFilter } from "@/components/controls/grid/columnfilters/ColumnFilters";
import type BaseEnumType from "@/app/services/baseEnumType";
import { translate } from "@/plugins/i18n";
import Key from "@/app/types/common/key";

export const enumFilterTypes: FilterType[] = [
  {
    type: "filter_equals",
    values: 1,
    applyFunc: (
      itemValue: any,
      formattedItemValue: any,
      filterValue: BaseEnumType
    ) => {
      // We have to get the translated value, as that's what's used on the enum.
      const enumTranslatedValue = translate(
        Key.fromString(filterValue.translationKey!)
      );

      return itemValue === enumTranslatedValue;
    },
  },
  {
    type: "filter_not_equals",
    values: 1,
    applyFunc: (
      itemValue: any,
      formattedItemValue: any,
      filterValue: BaseEnumType
    ) => {
      // We have to get the translated value, as that's what's used on the enum.
      const enumTranslatedValue = translate(
        Key.fromString(filterValue.translationKey!)
      );

      return itemValue !== enumTranslatedValue;
    },
  },
];

export function buildApplyEnumFilter(state: FilterState): FilterFunc {
  return buildApplyFilter(state, enumFilterTypes);
}
